import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ReactPlayer from "react-player";

import "./assets/css/custom.css";
import { langResources, resources } from "../utilities/utilsFunction";
import { languages } from "../constant";
import { Circle } from "../components/Overlay";

const CaseWeb = ({ userSchemes, langId, visible }) => {
  const customRenderItem = (item, props) => (
    <item.type {...item.props} {...props} />
  );
  langId = langId ? langId : 1;

  let filteredSchemes = [];
  userSchemes.forEach((i) => {
    var index = filteredSchemes.findIndex(
      (x) => x?.scheme?.docUrl == i?.scheme?.docUrl
    );
    if (index === -1 && i.scheme?.language === languages[langId]) {
      filteredSchemes.push(i);
    }
  });

  const YoutubeSlide = ({ url, isSelected }) => (
    <div style={{ position: "relative", paddingTop: "56.25%" }}>
      <ReactPlayer
        style={{ position: "absolute", top: 0, left: 0 }}
        url={url}
        controls={true}
        playing={isSelected}
        width="100%"
        height="100%"
      />
    </div>
  );

  const youtubeRegEx =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

  return (
    <div
      style={{
        height: "100%",
        width: "96%",
        margin: "0 auto",
        paddingBottom: "40px",
      }}
    >
      <div className="title-col">
        <h2 className="title wow fadeInUp" style={{ marginBottom: "-5px" }}>
          {langResources[resources[langId]]["offersForYou"]}
        </h2>
      </div>
      {!!filteredSchemes?.length && (
        <Carousel
          infiniteLoop={false}
          autoPlay={false}
          showStatus={false}
          showIndicators={false}
          showArrows={true}
          swipeable={true}
          emulateTouch={true}
          renderItem={customRenderItem}
        >
          {filteredSchemes?.map((val) => {
            return val?.scheme?.docUrl.match(youtubeRegEx) ? (
              <YoutubeSlide url={val?.scheme?.docUrl} />
            ) : (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <iframe
                  allowscriptaccess="always"
                  key={val?.scheme?.docUrl}
                  style={{
                    width: "97%",
                    height: "100%",
                    padding: 0,
                    margin: 0,
                  }}
                  src={val?.scheme?.docUrl ?? ""}
                />
              </div>
            );
          })}
        </Carousel>
      )}
      {visible && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignContent: "center",
            backgroundColor: "rgb(0,0,0,0.3)",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <Circle size="Large" top={"30%"} />
        </div>
      )}
      {!visible && !filteredSchemes?.length && (
        <div
          style={{
            width: "97%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              alignSelf: "center",
            }}
          >
            {langResources[resources[langId]]["noOffersAvailable"]}
          </h2>
        </div>
      )}
    </div>
  );
};

export default CaseWeb;
